<template>
  <button
    class="whitespace-nowrap h-6"
    @click.prevent="handleReviewsClick"
  >
    <DynamicStars
      v-bind="{ count, rating }"
      class="pointer-events-none"
    />
  </button>
</template>

<script setup lang="ts">
import { useThemeStore } from '@/stores'
import { DynamicStars } from '@oatsovernight/storybook'
import ProductReviewsModal from '@/components/products/product-reviews-modal.vue'

const { modal } = useThemeStore()
const props = defineProps<{
  productId: number
  productTitle: string
  count: number
  rating: number
}>()

const handleReviewsClick = () => {
  if (props.count > 0) {
    const { productId, productTitle } = props
    modal.open(ProductReviewsModal, { productId, productTitle })
  }
}
</script>
